module.exports = __webpack_public_path__ + "media/images/bg/shapes/courses-at-school-d8bf588f32aac47d3c9ecad6b855ecfc.svg";